
import NewComponent from "../../../components/lottery_coupons/New.vue";

export default {
  components: {
    NewComponent,
  },
};
